import ScaleLoader from "react-spinners/ScaleLoader";
import { useState } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from "antd";
// import { css } from "@emotion/react";

export default function FullScreenLoader() {
  return (
    <div className="loaderDiv">
      <div className="spinner">
        <ScaleLoader
          color="white"
          loading="true"
          // cssOverride={override}
          size={150}
        />
      </div>
    </div>
  );
}

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export function Loader1() {
  const [loading, setLoading] = useState(true);
  return (
    <div className="text-align-center loader_white">
      <Spin indicator={antIcon} loading={loading}
        size={30}
        fill="#ffffff"
        setLoading={setLoading}/>
    </div>
  );
}
